module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("Logo color")]), _vm._v(" "), _c('div', {
    staticClass: "logo-box logo-box1 mt--bg--neutrals-light-gray-01"
  }, [_c('mt-logo', {
    attrs: {
      "propWidth": 300
    }
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Color usage")]), _vm._v(" "), _c('div', {
    staticClass: "iconBoxWrap"
  }, [_c('div', {
    staticClass: "icon-box mt--bg--neutrals-light-gray-01"
  }, [_c('mt-logo', {
    attrs: {
      "propIsShowText": false,
      "propWidth": 500
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-box mt--bg--neutrals-dark-gray-02"
  }, [_c('mt-logo', {
    attrs: {
      "propIsShowText": false,
      "propWidth": 500,
      "propColor": "#ffffff",
      "propIsWhiteIcon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-box mt--bg--neutrals-light-gray-01"
  }, [_c('mt-logo', {
    attrs: {
      "propIsShowText": false,
      "propWidth": 500,
      "propIsBlackIcon": "",
      "propColor": "#485464"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Logos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cefc310","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logos.vue
// module id = Ak93
// module chunks = 0